module.exports = __webpack_public_path__ + "img/twobottomlan.892b312f.svg";